var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("form", { staticClass: "gen-form", attrs: { "data-form": "profile" } }, [
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("ID")]),
        _c("input", {
          attrs: { type: "text", name: "login", disabled: "" },
          domProps: { value: _vm.Lead.info.login },
        }),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Firstname")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.Lead.info.firstname,
              expression: "Lead.info.firstname",
            },
          ],
          attrs: { type: "text", name: "firstname" },
          domProps: { value: _vm.Lead.info.firstname },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.Lead.info, "firstname", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Lastname")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.Lead.info.lastname,
              expression: "Lead.info.lastname",
            },
          ],
          attrs: { type: "text", name: "lastname" },
          domProps: { value: _vm.Lead.info.lastname },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.Lead.info, "lastname", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Email")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.Lead.info.email,
              expression: "Lead.info.email",
            },
          ],
          attrs: { type: "text", name: "email" },
          domProps: { value: _vm.Lead.info.email },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.Lead.info, "email", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Last call date")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.Lead.info.lastcalldate,
              expression: "Lead.info.lastcalldate",
            },
          ],
          attrs: { type: "text", name: "lastcalldate" },
          domProps: { value: _vm.Lead.info.lastcalldate },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.Lead.info, "lastcalldate", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Number of calls")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", name: "callnum", disabled: "" },
          domProps: { value: _vm.Lead.info.callnum },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Registration time")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", name: "createdtime", disabled: "" },
          domProps: { value: _vm.Lead.info.createdtime },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Date")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", name: "createddate", disabled: "" },
          domProps: {
            value: _vm.Lead.info.createddate + _vm.Lead.info.createdtime,
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Landing")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.Lead.info.landing,
              expression: "Lead.info.landing",
            },
          ],
          attrs: { type: "text", name: "landing" },
          domProps: { value: _vm.Lead.info.landing },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.Lead.info, "landing", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Aff.id")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", name: "affid", disabled: "" },
          domProps: { value: _vm.Lead.info.affid },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Campaign id")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", name: "campaignid", disabled: "" },
          domProps: { value: _vm.Lead.info.campaignid },
        }),
      ]),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Comment")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", name: "lastcomment", disabled: "" },
          domProps: { value: _vm.Lead.info.lastcomment },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Last comment date")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", name: "lastcommentdate", disabled: "" },
          domProps: { value: _vm.Lead.info.lastcommentdate },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Sms ver.required")]),
        _c("input", {
          attrs: { type: "text", name: "smsverreq", disabled: "" },
          domProps: { value: _vm.Lead.info.smsverreq },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Sms verified")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", name: "smsver", disabled: "" },
          domProps: { value: _vm.Lead.info.smsver },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Sms ver.land.")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", name: "cifver", disabled: "" },
          domProps: { value: _vm.Lead.info.cifver },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Lead ID")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", name: "id", disabled: "" },
          domProps: { value: _vm.Lead.info.id },
        }),
      ]),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _vm._m(5),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Deposit status date")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", name: "depsatusdd", disabled: "" },
          domProps: { value: _vm.Lead.info.depsatusdd },
        }),
      ]),
      _vm._v(" "),
      _vm._m(6),
      _vm._v(" "),
      _vm._m(7),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Last online time")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", name: "lastlonline", disabled: "" },
          domProps: { value: _vm.Lead.info.lastlonline },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-fieldset__item" }, [
        _c("label", [_vm._v("Last offlime time")]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "text", name: "lastoffline", disabled: "" },
          domProps: { value: _vm.Lead.info.lastoffline },
        }),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(8),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gen-fieldset__item" }, [
      _c("label", [_vm._v("Brand")]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-select-container " }, [
        _c(
          "div",
          {
            staticClass: "ui-ddbox ui-ddbox-select ui-ddbox-select-ajax-0",
            attrs: {
              "data-name": "home",
              "data-id": "32172",
              "data-task": "home",
            },
          },
          [
            _c("button", { staticClass: "ui-ddbtn" }, [
              _c(
                "span",
                {
                  staticClass: "ui-ddbtnvalue",
                  attrs: { "data-value": "Fxbullion.com" },
                },
                [
                  _c("img", {
                    attrs: { src: "/img/home/t_logo_Fxbullion.com.png" },
                  }),
                  _vm._v("fxbullion.com"),
                ]
              ),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-caret-down",
                attrs: { "aria-hidden": "true" },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui-ddbody" }, [
              _c("div", { staticClass: "ui-ddsection" }, [_c("div")]),
            ]),
          ]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gen-fieldset__item" }, [
      _c("label", [_vm._v("Country")]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-select-container " }, [
        _c(
          "div",
          {
            staticClass: "ui-ddbox ui-ddbox-select ui-ddbox-select-ajax-0",
            attrs: {
              "data-name": "country",
              "data-id": "32172",
              "data-task": "country",
            },
          },
          [
            _c("button", { staticClass: "ui-ddbtn" }, [
              _c(
                "span",
                { staticClass: "ui-ddbtnvalue", attrs: { "data-value": "" } },
                [_vm._v("Ukraine")]
              ),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-caret-down",
                attrs: { "aria-hidden": "true" },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui-ddbody" }, [
              _c("div", { staticClass: "ui-ddsection" }, [_c("div")]),
            ]),
          ]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gen-fieldset__item" }, [
      _c("label", [_vm._v("Employee")]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-select-container " }, [
        _c(
          "div",
          {
            staticClass: "ui-ddbox ui-ddbox-select ui-ddbox-select-ajax-0",
            attrs: {
              "data-name": "assign",
              "data-id": "32172",
              "data-task": "assign",
            },
          },
          [
            _c("button", { staticClass: "ui-ddbtn" }, [
              _c(
                "span",
                { staticClass: "ui-ddbtnvalue", attrs: { "data-value": "2" } },
                [_vm._v("No User")]
              ),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-caret-down",
                attrs: { "aria-hidden": "true" },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui-ddbody" }, [
              _c("div", { staticClass: "ui-ddsection" }, [_c("div")]),
            ]),
          ]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gen-fieldset__item" }, [
      _c("label", [_vm._v("Status")]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-select-container " }, [
        _c(
          "div",
          {
            staticClass: "ui-ddbox ui-ddbox-select ui-ddbox-select-ajax-0",
            attrs: {
              "data-name": "leadstatus",
              "data-id": "32172",
              "data-task": "leadstatus",
            },
          },
          [
            _c("button", { staticClass: "ui-ddbtn" }, [
              _c(
                "span",
                { staticClass: "ui-ddbtnvalue", attrs: { "data-value": "" } },
                [_vm._v("Voicemail")]
              ),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-caret-down",
                attrs: { "aria-hidden": "true" },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui-ddbody" }, [
              _c("div", { staticClass: "ui-ddsection" }, [_c("div")]),
            ]),
          ]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gen-fieldset__item" }, [
      _c("label", [_vm._v("Type")]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-select-container " }, [
        _c(
          "div",
          {
            staticClass: "ui-ddbox ui-ddbox-select ui-ddbox-select-ajax-0",
            attrs: {
              "data-name": "ltype",
              "data-id": "32172",
              "data-task": "ltype",
            },
          },
          [
            _c("button", { staticClass: "ui-ddbtn" }, [
              _c(
                "span",
                { staticClass: "ui-ddbtnvalue", attrs: { "data-value": "" } },
                [_vm._v("Depositor")]
              ),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-caret-down",
                attrs: { "aria-hidden": "true" },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui-ddbody" }, [
              _c("div", { staticClass: "ui-ddsection" }, [_c("div")]),
            ]),
          ]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gen-fieldset__item" }, [
      _c("label", [_vm._v("Dep.status")]),
      _vm._v(" "),
      _c("div", { staticClass: "gen-select-container gen-select-border-0" }, [
        _c(
          "div",
          {
            staticClass: "ui-ddbox ui-ddbox-select ui-ddbox-select-ajax-0",
            attrs: {
              "data-name": "depstatus",
              "data-id": "32172",
              "data-task": "depstatus",
            },
          },
          [
            _c("button", { staticClass: "ui-ddbtn-view" }, [
              _c(
                "span",
                { staticClass: "ui-ddbtnvalue", attrs: { "data-value": "" } },
                [_vm._v("-")]
              ),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-caret-down",
                attrs: { "aria-hidden": "true" },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui-ddbody" }, [
              _c("div", { staticClass: "ui-ddsection" }, [_c("div")]),
            ]),
          ]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gen-fieldset__item" }, [
      _c("label", [_vm._v("Has duplicated?")]),
      _vm._v(" "),
      _c("input", {
        attrs: {
          type: "text",
          name: "hasduplicates",
          value: "Yes",
          disabled: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gen-fieldset__item" }, [
      _c("label", [_vm._v("Online")]),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "text", name: "online", value: "1", disabled: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gen-form-post-btns" }, [
      _c("button", { staticClass: "btn gen-form-post" }, [
        _c("span", [_vm._v("Update")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }